import React, { useState} from 'react';

import {Button, message, Select, Table, Typography} from "antd";
import {useMutation, useQuery} from "@tanstack/react-query";
import { getDownURL,getCaseId } from "../../api/AuditTrailAPI";


const CaseDownList = () => {
    const { Option } = Select;
    const { Text } = Typography;
    const [selectedCases, setSelectedCases] = useState([]);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState('파일 다운로드');

    const { data: caseData = [], isLoading } = useQuery(['caseIDs'], () => getCaseId());

    // const caseData = [
    //     {key: "1", caseNumber: "CASE-001"},
    //     {key: "2", caseNumber: "CASE-002"},
    //     {key: "3", caseNumber: "CASE-003"},
    // ];

    const handleChange = (value) => {
        setSelectedCases(value);
    };

    const { mutate: downloadFile } = useMutation(getDownURL, {
        onSuccess: (data) => {
            // console.log("다운로드 URL 성공:", data);
            if (data && data.data) {
                window.location.href = data.data;
                message.success("파일 다운로드를 시작합니다., ");
            } else {
                message.error("Zip File 만들기를 실패했습니다.");
            }
            setState('브라우저 다운로드창을 확인하세요! 다른 케이스를 다운로드 하시려면 새로고침하세요.')
            // setLoading(false);
        },
        onError: (error) => {
            console.error("다운로드 실패:", error);
            message.error("파일 다운로드에 실패했습니다.");
            setLoading(false);
        }
    });

    const fetchDownloadURL = async () => {
        if (selectedCases.length === 0) {
            message.warning("케이스 번호를 선택하세요.");
            return;
        }
        setLoading(true);
        setState('Zip 파일을 생성하고 있습니다. 최대 15분, 크기 2G 이하만 가능 합니다.')
        downloadFile(selectedCases);
    };



    return (
        <div>
            <Text strong>케이스 번호 선택:</Text>
            <Select
                // mode="multiple"
                showSearch
                optionFilterProp="children"
                style={{ width: "100%" }}
                placeholder="케이스 번호를 선택하세요"
                onChange={handleChange}
            >
                {caseData?.data.map((item) => (
                    <Option key={item} value={item}>
                        {item}
                    </Option>
                ))}
            </Select>
            <Button type="primary" onClick={fetchDownloadURL} loading={loading} style={{ marginTop: 10 }}>
                {state}
            </Button>
        </div>
    );
};

export default CaseDownList;